const testimontialSlides = document.querySelectorAll(".c-quote__right");
const changeBtn = document.querySelector(".testimontial-slide-changer");
let slideCounter = 0;
changeTestimontalSlide();
changeBtn.addEventListener("click", () => {
  if (slideCounter + 1 == testimontialSlides.length) {
    slideCounter = 0;
  } else {
    slideCounter++;
  }

  changeTestimontalSlide();
});

function changeTestimontalSlide() {
  testimontialSlides.forEach((el) => {
    el.classList.add("hidden");
  });
  testimontialSlides[slideCounter].classList.remove("hidden");
}
